import React from 'react';
import SearchReportsItems from './components/SearchReportsItems';
import Downloads from './components/Downloads';
import BostonMayoralElection from './BostonMayoralElection';


const routes = [
  {
    path: '/Data/SearchItems',
    renderer: (params = {}): JSX.Element => <SearchReportsItems {...params} />,
  },
  {
    path: '/Reports/SearchItems',
    renderer: (params = {}): JSX.Element => <SearchReportsItems {...params} />,
  },
  {
    path: '/Data/Downloads',
    renderer: (params = {}): JSX.Element => <Downloads {...params} />,
  },
  {
    path: '/Data/BostonMayoralElection',
    renderer: (params = {}): JSX.Element => <BostonMayoralElection {...params} />,
  }
];

export default routes;
